import { render, staticRenderFns } from "./AuthenticatedSendersList.vue?vue&type=template&id=a1a71092&"
import script from "./AuthenticatedSendersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./AuthenticatedSendersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports